import React from 'react';
import { Link } from 'react-router-dom';
import { ComponentTheme } from '../../definitions/components';
import { isExternalLink } from '../../services/utils';
import './Button.css';

interface IButtonProps {
  theme?: ComponentTheme;
  classname?: string;
  link: string;
  text?: string;
  target?: string;
  rel?: string;
}

const Button = ({
  theme,
  classname = '',
  link,
  text = 'Read More',
  target,
  rel,
}: IButtonProps) => {
  const props = { className: `themed-btn ${theme} ${classname}`, target, rel };
  return isExternalLink(link)
    ? <a {...props} href={link}>{text}</a>
    : <Link {...props} to={link}>{text}</Link>;
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx